module.exports = __webpack_public_path__ + "img/Boulangerie.f6f955db.jpg";